// ? [REVISIT] manually review this file
//@ts-nocheck

import 'bootstrap/js/dist/tab';

import '../../styles/templates/collection.generic-slap.scss';

const slapPageDefaultTab = 'Women';

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash !== '' && window.location.hash !== slapPageDefaultTab) {
    const newActiveTab = window.location.hash.slice(1);
    // Tabs
    document.querySelector(`a.slap-tab[href="#${slapPageDefaultTab}"]`).classList.remove('active');
    document.querySelector(`a.slap-tab[href="#${newActiveTab}"]`).classList.add('active');
    // Sections
    document.getElementById(slapPageDefaultTab).classList.remove('active', 'show');
    document.getElementById(newActiveTab).classList.add('active', 'show');
  }
});

/* Reattach the built-in browser behavior that Bootstrap kills by preventingDefault,
 * so that the clicks DO affect the hash in the URL
 * I could use location.href= instead of History API but I actually don't want to affect the scroll position */
document.querySelectorAll('a.slap-tab').forEach((anchor) => {
  anchor.addEventListener('click', function (e) {
    if (e.currentTarget.hash === `#${slapPageDefaultTab}`) {
      /* Prevents linking to a redundant #Women */
      window.history.replaceState({}, window.title, e.currentTarget.href.replace(e.currentTarget.hash, ''));
    } else {
      window.history.replaceState({}, window.title, e.currentTarget.href);
    }
  });
});
